<template>
  <div class="md-layout">
    <div class="md-layout-item wraps">
      <v-dialog
        v-model="showTagList"
        scrollable
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card class="pa-4">
          <v-card-title>
            <span class="md-title" style="color: #67ad5b">标签搜索</span>
          </v-card-title>
          <v-card-text>
            <v-select
              :items="tagList"
              v-model="searchTags"
              item-value="_id"
              item-text="name"
              label="标签"
              multiple
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" dark @click="refreshResourceList">搜索</v-btn>
            <v-btn @click="showTagList = false">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showQrCodeStatus"
        scrollable
        :overlay="false"
        max-width="200px"
        transition="dialog-transition"
      >
        <v-card>
          <img :src="url" alt="" style="width: 200px; height: 200px" />
        </v-card>
      </v-dialog>
      <!-- 此处是为了兼容移动端故而备份了这个几个下拉列表 -->
      <!-- <md-toolbar style="height:44px;min-height:44px"></md-toolbar> -->
      <md-toolbar
        elevation="0"
        class="mobileShow"
        style="height: 44px; min-height: 44px; padding: 0px 20px; margin: 10px 0px"
      >
        <span
          style="
            width: 80px;
            float: left;
            color: #fff;
            margin: 0px;
            height: 44px;
            line-height: 44px;
          "
          >模型资源库</span
        >
        <v-btn
          large
          class="md-button md-success dropdown-toggle addModel"
          @click="handleResourceNew"
          style="height: 44px; line-height: 44px"
        >
          <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
          >添加模型
        </v-btn>

        <div class="d-sm-flex justify-between" style="display: none" v-if="!isMoible.isMoible">
          <div style="display: inline-block" @mouseenter="mouseenter" @mousedown="mouseDown">
            <el-cascader
              size="small"
              placeholder="全部"
              @change="onchange"
              v-model="optionsValue"
              :props="cascaderProps"
              id="coursefilterWrap"
              ref="coursefilterWrap"
            >
            </el-cascader>
          </div>
        </div>

        <md-button
          v-if="isMobile.isMobile"
          class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
          :class="{ toggled: $sidebar.showSidebar }"
          style="float: right; color: #fff !important; margin-right: -5px"
          @click.stop="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
      </md-toolbar>
      <!-- 此处是为了兼容移动端故而备份了这个几个下拉列表 -->
      <v-card
        class="md-layout md-alignment-center"
        :class="isMoible.isMoible ? 'DeviceLibWrap' : ''"
        :style="{ padding: isMoible.isMoible ? '10px 0px 0px' : '0px' }"
      >
        <!-- 搜索栏  -->
        <v-toolbar color="success" class="pcShow">
          <span style="width: 80px; float: left; color: #fff; margin: 20px">模型资源库</span>

          <v-btn
            large
            class="md-button md-success dropdown-toggle addModel"
            @click="handleResourceNew"
          >
            <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
            >添加模型
          </v-btn>

          <v-spacer></v-spacer>
          <div class="d-sm-flex justify-between">
            <div class="d-flex ms-auto">
              <div style="display: inline-block" @mouseenter="mouseenter" @mousedown="mouseDown">
                <el-cascader
                  size="small"
                  placeholder="全部"
                  @change="onchange"
                  v-model="optionsValue"
                  :props="cascaderProps"
                  id="coursefilterWrap"
                  ref="coursefilterWrap"
                >
                </el-cascader>
                <!-- <md-tooltip md-direction="top">{{ tooltipValue }}</md-tooltip> -->
              </div>
            </div>
          </div>
        </v-toolbar>

        <div style="overflow: hidden; height: auto; background-color: #fff">
          <v-card-text
            class="DeviceLibWrap"
            :style="{ padding: isMobile.isMobile ? '10px 0px 0px' : '10px 5px 5px' }"
          >
            <v-toolbar flat height="80" style="padding: 0px">
              <v-text-field
                v-model="searchQuery"
                class="filterValue"
                append-icon="mdi-magnify"
                label="请输入名称"
                single-line
                hide-details
                @keydown="keydownSearch"
              ></v-text-field>

              <md-tooltip md-direction="top">按回车以检索</md-tooltip>
            </v-toolbar>
            <v-row dense class="modelListWrap">
              <v-progress-linear
                v-show="loading"
                :active="loading"
                :indeterminate="loading"
              ></v-progress-linear>

              <v-col
                v-if="courseListLoading && !isMobile.isMobile"
                v-for="(item, index) in 8"
                :key="index"
                class="guJiaWrap md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-25"
              >
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`">
                  <v-skeleton-loader
                    class="mx-auto"
                    max-width="100%"
                    type="card"
                  ></v-skeleton-loader>
                </v-sheet>
              </v-col>

              <div
                :style="{
                  display: 'flex',
                  justifyContent: 'space-around',
                  flexWrap: 'wrap',
                  width: isMobile.isMobile ? '95%' : '0',
                }"
                v-if="courseListLoading && isMobile.isMobile"
              >
                <v-col
                  v-for="n in 8"
                  :key="n"
                  cols="6"
                  class="guJiaWrap md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-45"
                  :style="{
                    height: isMobile.isMobile ? '110px' : '239px',
                    margin: isMobile.isMobile ? '10x 0px' : '5px 0',
                    padding: isMobile.isMobile ? '0px' : '',
                  }"
                >
                  <v-skeleton-loader
                    type="card"
                    :style="{ height: isMobile.isMobile ? '110px' : '239px' }"
                    class="mb-4"
                  />
                   
                </v-col>
              </div>

              <div
                v-if="modelResourceList.length > 0"
                v-for="(modelResource, index) in modelResourceList"
                :key="modelResource.id"
                :class="
                  isMobile.isMobile
                    ? 'modelList'
                    : 'modelList md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100'
                "
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-expand-transition>
                      <v-card
                        hover
                        :class="[`elevation-${hover ? 20 : 2}`, 'mx-2', 'transition-swing','vcardWrap']"
                        @click="handleResourceDetail(modelResource)"
                        :max-height="isMobile.isMobile ? '105' : '239'"
                        :height="isMobile.isMobile ? '105' : '239'"
                        :style="{margin:isMobile.isMobile?'0px !important':'0 8px'}"
                      >
                        <div class="cardWrap">
                          <v-img
                            :src="modelResource.model_image"
                            :lazy-src="modelResource.model_image"
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            :height="isMobile.isMobile ? '80px' : '200'"
                            :max-height="isMobile.isMobile ? '80px' : '200'"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <div style="position: absolute; top: 0; right: 2px; z-index: 7">
                            <v-btn
                              icon
                              :color="modelResource.isCollect ? 'red' : 'grey'"
                              @click.stop="clickcollect(modelResource)"
                              class="button"
                            >
                              <v-icon>mdi-heart</v-icon>
                              <md-tooltip md-direction="top">点击收藏</md-tooltip>
                            </v-btn>
                            <v-btn icon @click.stop="showQrCode" class="button">
                              <span
                                class="iconfont icon-fenxiang1"
                                style="font-size: 22px; color: #fff"
                              ></span>
                              <md-tooltip md-direction="top">分享</md-tooltip>
                            </v-btn>
                          </div>

                          <div class="maskingWrap">
                            <p style="color: #fff; padding: 5px; width: 80%; float: left">
                              {{ modelResource.description }}
                            </p>

                            <v-spacer></v-spacer>

                            <div class="iconWrap">
                              <v-btn color="success" style="float: right" text small>免费</v-btn>
                            </div>
                          </div>
                        </div>

                        <v-card-actions class="model_name">
                          <p style="margin: 0px">
                            {{ modelResource.model_name }}
                          </p>
                        </v-card-actions>
                      </v-card>
                    </v-expand-transition>
                  </template>
                </v-hover>
              </div>
            </v-row>
          </v-card-text>
          <!-- 分页 -->
          <Pagination
            :page.sync="pagination.page"
            :total="pagination.total"
            :itemsSelect="[4, 8, 20, 40]"
            :items-per-page.sync="pagination.itemsPerPage"
            @refresh="refreshResourceList"
          />
        </div>
        <DeviceLibDetail
          :showDetailDialog="showDetailDialog"
          :selectedResource="selectedResource"
          @handleDetailCancel="handleDetailCancel"
          @handleDetailSubmit="handleDetailSubmit"
          v-if="showDetailDialog"
        />
        <DeviceLibNew
          :showNewDialog="showNewDialog"
          @handleCloseDialog="handleCloseDialog"
          v-if="showNewDialog"
        />
        <ModelPreview
          v-if="previewModelStatus"
          :model-id="model_id"
          :showDialog.sync="previewModelStatus"
        />
      </v-card>
    </div>
  </div>
</template>
<script>
import DeviceLibDetail from './Action/DeviceLibDetail';
import DeviceLibNew from './Action/DeviceLibNew';
import ModelPreview from './Action/ModelPreview.vue';
import Pagination from '@/components/Pagination/index';
import { refreshResourceList, setcollect } from '@/api/model_resource';
import { listTag } from '@/api/tag';
import QRcode from 'qrcode';
import { _Base64encode } from '@/util/base64';
import { categoryList } from '../../../../api/user';
import { mapGetters } from 'vuex';
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: 'DeviceLib',
  components: {
    DeviceLibDetail,
    DeviceLibNew,
    ModelPreview,
    Pagination,
  },
  computed: {
    ...mapGetters(['isMobile']),
    isMoible() {
      return this.$store.state.isMobile;
    },
  },
  data() {
    return {
      courseListLoading: false,
      // 选中的模型id
      model_id: '',
      // 模型展示弹框控制
      previewModelStatus: false,
      // 搜索条件
      searchQuery: '',
      // 加载
      loading: true,
      // 查询参数

      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
      },
      showDetailDialog: false,
      showNewDialog: false,
      checkList: [],
      selectedItem: {},
      modelResourceList: [],
      selectedResource: {},
      tagList: [],
      searchTags: [],
      showTagList: false,
      showQrCodeStatus: false,
      url: '',
      tooltipVisible: false,

      optionsValue: ['all'],
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: true,
        lazyLoad: (node, resolve) => {
          let that = this;
          const { level } = node;

          setTimeout(() => {
            if (node.level == 0) {
              let options = [
                {
                  name: '全部',
                  code: 'all',
                  level: 0,
                },
                {
                  name: '设备',
                  code: 'device',
                  level: 0,
                },
                {
                  name: '角色',
                  code: 'role',
                  level: 0,
                },
                {
                  name: '工具',
                  code: 'tool',
                  level: 0,
                },
                {
                  name: '场景',
                  code: 'scene',
                  level: 0,
                },
              ];
              resolve(options);
            }
            if (node.level == 1) {
              if (node.value == '') {
                return;
              }
              let params = {
                cate_type: node.value || '',
                level: '1',
                parentCode: '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data.unshift({
                    name: '全部',
                    code: '-1',
                  });
                  res.data.forEach(item => {
                    item.leaf = true;
                  });
                  resolve(res.data);
                }
              });
            }
            if (node.level == 2) {
              // let params = {
              //   cate_type: node.parent.value || '',
              //   level: '2',
              //   parentCode: node.value || '',
              // };
              // categoryList(params).then(res => {
              //   if (res.data) {
              //     res.data.forEach(item => {
              //       item.leaf = true;
              //     });
              //     resolve(res.data);
              //   }
              // });
            } else if (node.level > 2) {
              resolve([]);
            }
          }, 100);
        },
      },
    };
  },
  watch: {
    optionsValue(val) {
      this.setCard();
    },
  },
  destroyed() {
    this.$EventBus.$off('viewModel');
  },

  created() {
    this.refreshResourceList();

    this.getTagList();
    let that = this;
    this.$EventBus.$on('viewModel', function (data) {
      if (data) {
        that.showDetailDialog = true;
      } else {
        that.showDetailDialog = false;
      }
    });
  },
  mounted() {
    this.courseListLoading = true;
    setTimeout(() => {
      this.setCard();
    }, 1000);
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    setCard() {
      let getNode = document.querySelector('.el-cascader .el-input__inner');
      let str = '';

      if (this.$refs.coursefilterWrap.getCheckedNodes()[0] == null) {
        getNode.style.width = 80 + 'px';
      } else {
        this.$refs.coursefilterWrap.getCheckedNodes()[0].pathLabels.forEach(item => {
          str += item;
        });
        if (str.indexOf('全部') !== -1) {
          getNode.style.width = str.length * 17 + 60 + 'px';
          return;
        }
        getNode.style.width = str.length * 17 + 60 + 'px';
      }
    },
    mouseenter() {
      let nodes = this.$refs['coursefilterWrap'].getCheckedNodes()[0].pathLabels;
      if (this.$refs['coursefilterWrap'].getCheckedNodes()[0].value == 'all') {
        this.tooltipVisible = true;
      } else {
        let toopValue = '';
        if (nodes[0]) {
          toopValue = nodes[0];
          if (nodes[1]) {
            toopValue = nodes[0] + '/' + nodes[1];
            if (nodes[2]) {
              toopValue = nodes[0] + '/' + nodes[1] + '/' + nodes[2];
            }
          }
        }
      }
    },
    mouseDown() {
      this.tooltipVisible = false;
    },

    onchange(data) {
      this.refreshResourceList();
    },
    clickcollect(data) {
      let params = {
        isCollect: data.isCollect == 1 ? 0 : 1,
        date: new Date(),
        _id: data._id,
      };
      if (params.isCollect == 0) {
        var date = new Date(2022, 9 - 1, 30, 8, 30);
        params.date = date;
      } else if (params.isCollect == 1) {
        params.date = new Date();
      }

      setcollect(params).then(res => {
        if (res.code == '200') {
          data.isCollect = data.isCollect == 1 ? 0 : 1;
          this.$notify({
            timeout: 1500,
            message: params.isCollect ? '收藏成功' : '取消收藏',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          // this.pagination.page = 1;
          this.refreshResourceList();
        }
      });
    },
    async showQrCode(item) {
      const _this = this;
      QRcode.toDataURL(
        'http://file-preview.icubespace.com/onlinePreview?url=' +
          encodeURIComponent(_Base64encode(item.model_file))
      ).then(url => {
        _this.url = url;
        _this.showQrCodeStatus = true;
      });
    },
    async getTagList() {
      const res = await listTag({ perPage: 1000, currentPage: 1 });
      this.tagList = res.data.rows;
    },
    /**
     * 模型展示
     */
    handleResourcePreview(model) {
      if (!model.model_amrt_file_list_json) {
        this.$store.dispatch('global/showWarningMsg', '模型尚未转换无法预览');
        return;
      }
      this.model_id = model._id;
      this.previewModelStatus = true;
    },

    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.page = 1;
        this.refreshResourceList();
      }
    },
    /**
     * 查看详情
     */
    handleResourceDetail(item) {
      this.showDetailDialog = true;
      this.selectedResource = item;
    },
    /**
     * 清除筛选
     */

    refreshResourceList() {
      let tempData1 = {
        model_name: this.searchQuery || '',
        one_level_classify: this.optionsValue[1] || '',
        page_no: this.pagination.page || '',
        status: '7',
        page_size: this.pagination.itemsPerPage,
        model_resource_category: this.optionsValue[0] || '',
        tags: this.searchTags,
      };
      this.showTagList = false;
      this.loading = true;
      refreshResourceList(tempData1)
        .then(res => {
          this.loading = false;
          this.courseListLoading = false;
          this.modelResourceList = res.data.items;
          this.pagination.total = res.data.total;
        })
        .catch(err => {
          this.courseListLoading = false;
        });
    },

    handleDetailSubmit(item) {
      this.refreshResourceList();
      this.showDetailDialog = false;
    },
    handleResourceNew() {
      this.showNewDialog = true;
    },
    submit() {
      this.$emit('handleSubmit', {});
    },
    cancel() {
      this.$emit('handleCancel', {});
    },
    handleDetailCancel() {
      this.showDetailDialog = false;
    },
    handleCloseDialog(res) {
      this.showNewDialog = false;
      if (res) {
        this.refreshResourceList();
        console.log(res);
      }
    },
    // chooseType({ type }) {
    //   this.type = type;

    //   this.refreshResourceList();
    // },
  },
};
</script>
<style scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}

.v-List-actived {
  background: #ddd;
}

.v-application .indigo--text {
  background: #fff;
}

.disable-color {
  color: #ddd !important;

  i {
    color: #ddd !important;
  }
}

.mobileShow {
  background: #4caf50 !important;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12); */
    border-radius: 0px !important;
    box-shadow: none !important;
  /* margin: 10px 0px; */
}
.mobileShow {
  display: none;
}
@media (max-width: 599px) {
  .pcShow {
    display: none;
  }
  .mobileShow {
    display: block;
  }
}
.cardWrap {
  position: relative;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
}

.maskingWrap {
  position: absolute;
  left: 9;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: #000000a3;
  transition: 0.5s;
  opacity: 0;
}

.cardWrap:hover .maskingWrap {
  opacity: 1;
}
.iconWrap {
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: flex-end;
}
.md-layout-item {
  padding-right: 0px;
}

#coursefilterWrap {
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 20px;
}

#coursefilterWrap >>> .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}
#coursefilterWrap >>> .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}
#coursefilterWrap >>> .el-input .el-input__inner::placeholder {
  color: #fff;
}
#coursefilterWrap >>> .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}
.guJiaWrap {
  margin: 5px 0;
}

.filterValue {
  padding-right: 0px;
  padding-left: 0px;
}

.modelList  {
    margin: 10px 0;
  }

@media (max-width: 1160px) {
  .modelList  {
    height: 160px !important;
    margin: 10px 0;
  }

  .vcardWrap {
    height: 160px !important;
  }

  .cardWrap {
    height: 130px !important;
  }

  .v-image{
    height: 130px !important;
  }
  .maskingWrap {
    height: 130px !important;
  }
  .model_name {
    height: 30px !important;
    line-height: 30px !important;
  }
  .model_name p {
    height: 30px !important;
    line-height: 30px !important;
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

@media (max-width: 850px) {
  .modelList  {
    height: 130px !important;
    margin: 10px 0;
  }

  .vcardWrap {
    height: 130px !important;
  }

  .cardWrap {
    height: 100px !important;
  }

  .v-image{
    height: 130px !important;
  }
  .maskingWrap {
    height: 100px !important;
  }
  .model_name {
    height: 30px !important;
    line-height: 30px !important;
  }
  .model_name p {
    height: 30px !important;
    line-height: 30px !important;
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

@media (max-width: 750px) {
  .modelList  {
    height: 100px !important;
    margin: 10px 0;
  }

  .vcardWrap {
    height: 100px !important;
  }

  .cardWrap {
    height: 80px !important;
  }

  .v-image{
    height: 80px !important;
  }
  .maskingWrap {
    height: 80px !important;
  }
  .model_name {
    height: 20px !important;
    line-height: 20px !important;
  }
  .model_name p {
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    margin-top: 0px;
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .button{
    width: 25px;
  }
  .DeviceLibWrap {
    padding: 10px 5px 5px;
  }

  /deep/v-toolbar__content {
    padding: 4px 0px !important;
  }

  .wraps {
    padding-left: 15px;
    padding-right: 15px;
  }
  /* .v-toolbar__content, .v-toolbar__extension{
    padding:4px 0px !important;
  } */
  .DeviceLibWrap .header div {
    padding: 4px 0px !important;
    /* background: rebeccapurple; */
  }

  .filterValue {
    margin-right: 0px;
    margin-left: 0px;
  }

  #coursefilterWrap {
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .modelListWrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-right: 5px;
    margin-left: 5px;
  }
  .modelList {
    width: 45% !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
    margin: 5px;
    height: 105px !important;
    /* margin: 10px 0px; */
  }

  .modelListWrap .modelList:nth-child(0) {
    margin-top: 0px !important;
  }
  .modelListWrap .modelList:nth-child(1) {
    margin-top: 0px !important;
  }

  .model_name {
    padding: 0px;
  }

  .model_name p {
    margin-left: 5px !important;
    margin-right: 5px !important;
      white-space: nowrap;      /* 防止文本换行 */
    overflow: hidden;         /* 隐藏超出容器的内容 */
    text-overflow: ellipsis;  /* 超出部分显示为省略号 */
    width: 150px; 
    text-align: center;
    margin-bottom: 0px;
    line-height: 25px;
    height: 25px;
    font-size: 10px;
  }
}

.DeviceLibWrap {
  box-shadow: none !important;
  background-color: transparent !important;
}
</style>
